import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { threadProjectsBackend } from './thread-projects.backend';
import { threadProjectsReducer } from './thread-projects.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('threadProjects', threadProjectsReducer),
    BackendModule.forFeature('threadProjects', threadProjectsBackend),
  ],
})
export class DatastoreThreadProjectsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/thread-projects/thread-projects.module.ts